import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../css/Galerie.css';

export default function GalerieViewer({ groups, selectedImage, onSelect, onClose }) {
  const [notice, setNotice] = useState(null);
  const entries = useMemo(() => groups.flatMap((group, categoryIndex) =>
    group.images.map(image => ({ image, categoryIndex, categoryName: group.name }))
  ), [groups]);
  const index = entries.findIndex(entry => entry.image === selectedImage);

  useEffect(() => {
    if (!selectedImage) setNotice(null);
  }, [selectedImage]);

  useEffect(() => {
    if (!notice) return;
    const timeout = setTimeout(() => setNotice(null), 3000);
    return () => clearTimeout(timeout);
  }, [notice]);

  const navigate = useCallback((direction) => {
    const next = entries[index + direction];
    if (index < 0 || !next) return;
    if (next.categoryIndex !== entries[index].categoryIndex) {
      setNotice({ name: next.categoryName });
    } else {
      setNotice(null);
    }
    onSelect(next.image);
  }, [entries, index, onSelect]);

  useEffect(() => {
    if (!selectedImage) return;
    const handleKeyDown = event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        navigate(event.key === 'ArrowLeft' ? -1 : 1);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, navigate]);

  return (
    <Modal
      show={!!selectedImage}
      onHide={onClose}
      centered
      size="xl"
      dialogClassName="gallery-modal"
      aria-labelledby="gallery-image-title"

    >
      {selectedImage && <>
        <button type="button" className="gallery-nav gallery-nav-previous"
          aria-label="Image précédente" disabled={index <= 0} onClick={() => navigate(-1)}>
          <span aria-hidden="true">❮</span>
        </button>
        <button type="button" className="gallery-nav gallery-nav-next"
          aria-label="Image suivante" disabled={index < 0 || index >= entries.length - 1} onClick={() => navigate(1)}>
          <span aria-hidden="true">❯</span>
        </button>
        <Modal.Header>
          <Modal.Title id="gallery-image-title">{selectedImage.name || 'Photo de la galerie'}</Modal.Title>
          <button type="button" className="gallery-close" aria-label="Fermer l’image" onClick={onClose}>
            <span aria-hidden="true">×</span>
          </button>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="gallery-category-notice" role="status" aria-live="polite" aria-atomic="true">
            {notice && <span>Changement de catégorie : {notice.name}</span>}
          </div>
          <div className="gallery-modal-content">
            <img src={selectedImage.image} alt={selectedImage.name || 'Photo de la galerie'} />
            {selectedImage.description && <div className="gallery-description">{selectedImage.description}</div>}
          </div>
        </Modal.Body>
      </>}
    </Modal>
  );
}
